import { SET_RECAPTCHA_API_KEY } from '../actions'
import { IActionObject, IRecaptchaToken } from '../interface'

const initialState: IRecaptchaToken = null

export default (state = initialState, action: IActionObject) => {
  switch (action.type) {
    case SET_RECAPTCHA_API_KEY:
      return action.payload
    default:
      return state
  }
}
